import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class PositionSolaceService {
  positionSolaceOption: Observable<any>;
  private positionSolaceState = new BehaviorSubject<any>(0);

  constructor() {
    this.positionSolaceOption = this.positionSolaceState.asObservable();
  }

  changeOption(option: any) {
    this.positionSolaceState.next(option);
  }
}
